// @flow
import Loadable from 'react-loadable'

import Loader from '@src/components/ui/ReactLoadableLoader'

const BalanceLoader = Loadable({
  loader: () => import('./BalanceContainer'),
  loading: Loader,
})

export default BalanceLoader
